import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import LightGallery from "lightgallery";
import LgVideo from "lightgallery/plugins/video";
import AOS from 'aos';
import 'aos/dist/aos.css';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.LightGallery = LightGallery;
window.LgVideo = LgVideo;

AOS.init();